import { render, staticRenderFns } from "./FormChangePass.vue?vue&type=template&id=73a321da&scoped=true"
import script from "./FormChangePass.vue?vue&type=script&lang=js"
export * from "./FormChangePass.vue?vue&type=script&lang=js"
import style0 from "./FormChangePass.vue?vue&type=style&index=0&id=73a321da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a321da",
  null
  
)

export default component.exports